export default "__VITE_ASSET__BlsTa3mT__"